<template>
  <div class="container-fluid">
      <div class="category item" :key="index" v-for="(category, index) in categories">
        <router-link :to="{path : '/category/'+ category['@attributes'].id }">
          <p class="category-item__name">{{category.name}}</p>
          <img :src="category.image" alt="">
        </router-link>
      </div>
  </div>
</template>

<script>

import axios from "axios"

export default {
  name: 'Categories',
  data() {
    return {
    categories: null,
    }
  },
  methods: {
    getCategories () {
      axios.get(process.env.VUE_APP_API_URL, {params: {
          categories: "get"
        }})
          .then((response) => {

            this.categories = response.data.category
          })
    },
  },
  mounted() {
    this.getCategories()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a:hover {
  text-decoration: none;
}
.container-fluid {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
}

.item {
  padding: 30px 30px 0 30px;
  max-width: 33%;
  flex: 1 1 calc((100% / 3) - 2rem);
  background: #f2f2f2;
}

.item img {
  width: 100%;
  max-width: 300px;
}

.category-item__name {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  margin-top: 0;
  flex-grow: 0;
  font-size: 20px;
  font-weight: 500;
  color: #0f202a;
  position: relative;
  padding-bottom: 10px;
  text-align: left;
}

.category-item__name:after {
  content: '';
  position: absolute;
  bottom: 0;
  height: 5px;
  background: #dd291a;
  width: 100%;
  left: 0;
}

@media (max-width: 750px) {
  .item {
    max-width: 50%;
    flex: 1 1 calc((100% / 2) - 1rem);
  }
}

@media (max-width: 520px) {
  .item {
    max-width: 100%;
    flex: 1 1 100%;
  }
}

</style>
